export default "__VITE_ASSET__Bt1yL1Hl__"